export const EXPORT_COLUMNS_TICKETS = {
  acknowledged_at: 'Acknowledged At',
  alert_source: 'Alert Source',
  assignee_name: 'Assignee',
  closed_at: 'Closed At',
  contained_at: 'Contained At',
  created_at: 'Created At',
  customer_ticket_id: 'Customer Ticket Id',
  detected_at: 'Detected At',
  id: 'Id',
  ingested_at: 'Ingested At',
  next_action: 'Next Action Owner',
  origination_source: 'Origination Source',
  organization_author: 'Author Organization',
  organization_label: 'Organization Label',
  organization_name: 'Organization Name',
  remediated_at: 'Remediated At',
  resolution_id: 'Resolution Id',
  resolution_name: 'Resolution',
  sub_category: 'Subcategory',
  summary: 'Summary',
  tags: 'Tags',
  ticket_category_id: 'Category Id',
  ticket_category_name: 'Category',
  ticket_priority_id: 'Priority Id',
  ticket_priority_name: 'Priority',
  ticket_status_id: 'Status Id',
  ticket_status_name: 'Status',
  ticket_type: 'Type Id',
  title: 'Title',
  type_name: 'Type',
  updated_at: 'Updated At',
  user_email: 'Author Email',
  user_name: 'Author',
  messages: 'Messages'
};

export const EXPORT_COLUMNS_TICKETS_INTERNAL = {
  ...EXPORT_COLUMNS_TICKETS,
  external_ticket_id: 'Jira Id',
  followup_date: 'Follow-Up Date',
  organization_id: 'Organization Id',
  organization_is_ir: 'Organization IS IR',
  owner_email: 'Owner Email',
  owner_id: 'Owner Id',
  owner_name: 'Owner',
  published_at: 'Published At',
  team_queue: 'Team Queue',
  ticket_priority_response_time: 'Priority Response Time',
  ticket_priority_response_type: 'Priority Response Comm.',
  user_id: 'Author Id',
  user_internal: 'Author Internal',
  feedback_rating: 'Feedback Rating',
  feedback_reason: 'Feedback Reason'
};

export const EXPORT_COLUMNS_CLOUD_SOURCES = [
  { value: 'DeviceID', label: 'Device ID' },
  { value: 'SourceID', label: 'Source ID' },
  { value: 'DeviceName', label: 'Device Name' },
  { value: 'Source', label: 'Source' },
  { value: 'Site', label: 'Site' },
  { value: 'IngestMethod', label: 'Ingest Method' },
  { value: 'LastSeen', label: 'Last Seen' },
  { value: 'State', label: 'State' },
  { value: 'OrganizationCode', label: 'Organization Code' },
  { value: 'OrganizationName', label: 'Organization Name' },
  { value: 'Status', label: 'Status' },
  { value: 'StatusUpdatedAt', label: 'Status Updated At' }
];
